import $ from 'jquery';

$(document).ready(function () {
    const $type = $('.js-stato-perizie');
    $type.find('[type=radio]').attr('disabled', false);
    const $input = $type.find('[name=internal_professional_type]');

    const handleVisibility = () => {
        const selectedValue = $input.val();
        if (selectedValue === 'aziendale') {
            $('.js-aziendale').removeClass('d-none').find('input').attr('disabled', false);
            $('.js-interno').addClass('d-none').find('input').attr('disabled', true);
        } else {
            $('.js-aziendale').addClass('d-none').find('input').attr('disabled', true);
            $('.js-interno').removeClass('d-none').find('input').attr('disabled', false);
        }
    }

    // Initialize visibility based on the default value on DOM load
    handleVisibility();

    $type.on('change', handleVisibility);
});
